export { default } from './GraduateStoriesInner';
export type { Props, Props as GraduateStoriesInnerProps } from './GraduateStoriesInner';
